import React, { Component } from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import Cookies from "universal-cookie";
import { NavHashLink as Link } from "react-router-hash-link";
import $ from "jquery";
//import $ from "jquery";
//import { Link, animateScroll as scroll } from "react-scroll";
const cookies = new Cookies();

//import AnchorLink from "react-anchor-link-smooth-scroll";
//import { AUTH_TOKEN, USERNAME } from '../constants';

const NAV_QUERY = gql`
  query nav($lang: LanguageCodeFilterEnum) {
    themeGeneralSettings {
      optionsPage {
        mainMenu {
          title
          titleEn
          url
        }
      }
    }
    notikumi(where: { language: $lang }) {
      edges {
        node {
          id
          title
          slug
        }
      }
    }
  }
`;

class Nav extends Component {
  state = {
    dataq: []
  };

  componentDidMount() {
    this.executeNav();
  }

  executeNav = async () => {
    const { client } = this.props;
    const cookieLang = cookies.get("lang");
    const result = await client.query({
      query: NAV_QUERY,
      variables: {
        lang: cookieLang
      }
    });

    const scrollWithOffset = (el, offset) => {
      const elementPosition = el.offsetTop - offset;
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth"
      });
    };

    const anchor = window.location.hash.split("#")[1];
    if (anchor) {
      const anchorEl = document.getElementById(anchor);

      if (anchorEl) {
        //anchorEl.scrollIntoView();
        setTimeout(() => {
          //console.log(anchorEl.offsetTop);
          scrollWithOffset(anchorEl, 100);
        }, 2000);
      }
    }

    function handleClick(e) {
      //console.log('The link was clicked.');
      $(".hamburger").removeClass("is-active");
    }

    const dataq = result.data.themeGeneralSettings.optionsPage.mainMenu.map(
      (prop, i) => {
        return (
          <li className="nav-item" key={i}>
            <Link
              scroll={el => scrollWithOffset(el, 100)}
              className="nav-link"
              to={"/" + cookies.get("lang").toLowerCase() + "/" + prop.url}
              alt={prop.title}
              onClick={
                handleClick
              }
            >
              {cookies.get("lang") === "LV" && prop.title}
              {cookies.get("lang") === "EN" && prop.titleEn}
            </Link>
            {prop.title === "Notikumi" &&
              result.data.notikumi.edges.map((notiks, i) => (
                <div key={i}>{notiks.node.title}</div>
              ))}
          </li>
        );
      }
    );
    this.setState({ dataq });
  };

  changeLV() {
    cookies.set("lang", "LV", { path: "/" });
    //this.props.history.push("?lang=lv");
    var baseRouteUrl = "/lv";

    if ((cookies.get("lang") === null || cookies.get("lang") === undefined)) {
      window.history.pushState('', '', baseRouteUrl);
    } else {
      window.history.pushState('', '', baseRouteUrl);

    }
    //window.history.pushState('', '', window.location.toString().replace('/en', '/lv'));
    window.location.reload(false);
  }
  changeEN() {
    cookies.set("lang", "EN", { path: "/" });
    //window.history.pushState('', '', window.location.toString().replace('/lv', '/en'));
    var baseRouteUrl = "/en";

    if ((cookies.get("lang") === null || cookies.get("lang") === undefined)) {
      window.history.pushState('', '', baseRouteUrl);
    } else {
      window.history.pushState('', '', baseRouteUrl);

    }

    window.location.reload(false);
  }

  render() {
    const { dataq } = this.state;
    return (
      <div className="nav-wrap">
        <div className="nav-sec-wrap">
          <nav className="nav-primary">
            <ul className="primary_navigation nav">{dataq}</ul>
          </nav>
        </div>

        {/* {cookies.get("lang") === "LV" &&
          <span onClick={this.changeLV.bind(this)} className="selected">LV</span><span onClick={this.changeEN.bind(this)}>EN</span>}
          {cookies.get("lang") === "EN" &&
            <span onClick={this.changeLV.bind(this)}>LV</span> <span onClick={this.changeEN.bind(this)} className="selected">EN</span>} */}

        {cookies.get("lang") === "LV" ? (
          <div className="bottom-wrap">
            <span data-lang="lv" onClick={this.changeLV.bind(this)} className="selected">
              LV
            </span>
            <span data-lang="en" onClick={this.changeEN.bind(this)}>EN</span>
          </div>
        ) : (
          <div className="bottom-wrap">
            <span data-lang="lv" onClick={this.changeLV.bind(this)}>LV</span>{" "}
            <span data-lang="lv"
              onClick={
                this.changeEN.bind(this)
              }
              className="selected" >
              EN
            </span>
          </div>
        )}
      </div>
    );
  }
}
export default withApollo(Nav);
